import { render, staticRenderFns } from "./AppFooterEmbed.vue?vue&type=template&id=c63c0004&scoped=true&"
import script from "./AppFooterEmbed.vue?vue&type=script&lang=js&"
export * from "./AppFooterEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterEmbed.vue?vue&type=style&index=0&id=c63c0004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63c0004",
  null
  
)

export default component.exports